/**
 * Utility functions for domain management
 */

export function isCustomDomain(host: string | null): boolean {
  if (!host) return false

  const mainDomain = process.env.NEXT_PUBLIC_DOMAIN || 'taylora.com'
  const vercelDomain = 'vercel.app'

  if (
    host === mainDomain ||
    host === `www.${mainDomain}` ||
    host.includes(vercelDomain)
  ) {
    return false
  }

  return true
}

export function getCookieDomain(host: string | null): string | undefined {
  if (!host) return undefined

  // Vercel deployments (staging/preview): return undefined so the browser
  // scopes the cookie to the current exact hostname.
  if (host.includes('vercel.app')) return undefined

  const mainDomain = process.env.NEXT_PUBLIC_DOMAIN || 'taylora.com'

  // Subdomains of the main domain (e.g. smartlearn.taylora.com) must share the
  // same cookie scope as the main domain. Otherwise the browser ends up with two
  // cookies of the same name — one scoped to .taylora.com and one to
  // .smartlearn.taylora.com — and Safari may read the parent-domain cookie,
  // causing a workspace desync after a switch.
  if (host.endsWith(`.${mainDomain}`)) {
    return `.${mainDomain}`
  }

  if (isCustomDomain(host)) {
    return `.${host}`
  }

  return `.${mainDomain}`
}
